/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import BookingStepItem from "../booking/steps/BookingStepItem";
import Skeleton from "./Skeleton";
import SkeletonText from "./SkeletonText";
import Flex from "../ui/Flex";
import Stack from "../ui/Stack";

// Mirrors ui/PluginCard.jsx
const StyledItem = styled((props) => <BookingStepItem {...props} />)`
  padding: 8px;
  break-inside: avoid;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const MediaSkeleton = styled((props) => <Skeleton {...props} />)`
  width: 100%;
  height: 228px;
  flex-shrink: 0;
`;

const TitleSkeleton = styled(SkeletonText)`
  min-height: 2lh;
`;

const Additional = styled(Stack)`
  border-top: 1px solid rgba(${({ theme }) => theme.colors.border.rgb});
  padding-top: 1rem;
`;

const PluginCardSkeleton = ({ withIncludes = false }) => (
  <StyledItem>
    <MediaSkeleton borderRadius={8} />
    <Flex $direction="column" $gap="1rem" $padding="0.5rem">
      <Flex $direction="column" $gap="0.5rem">
        <TitleSkeleton size="h3" width="70%" />
        <SkeletonText lines={2} />
      </Flex>
      {withIncludes && (
        <Additional $gap="0.25rem">
          <SkeletonText width="80%" />
          <SkeletonText width="60%" />
          <SkeletonText width="70%" />
        </Additional>
      )}
      <Flex $direction="column" $gap="0.5rem">
        {withIncludes && <Skeleton borderRadius={8} width="100%" height={42} />}
        <Skeleton borderRadius={8} width="100%" height={42} />
      </Flex>
    </Flex>
  </StyledItem>
);

export default PluginCardSkeleton;
